import React from 'react';
import i18next from 'i18next';

import EmptyStatePage from '~/modules/coreUI/components/layouts/emptyStatePage';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { Label } from '~/modules/coreUI/components/basic/Labels';

const WrongPage = () => (
  <Column spaceBetween={1.5}>
    <Spacer size={2.5} />
    <Label header>
      {i18next.t('ecommerceCoreUI:WrongPages.errorTitle')}
    </Label>
    <Label semiBold important size={7}>
      {i18next.t('ecommerceCoreUI:WrongPages.errorTypeOfWrongRoute')}
    </Label>
    <EmptyStatePage
      imagePath={`/${imagesPathName}/cactus.png`}
      contentHeader={i18next.t('ecommerceCoreUI:WrongPages.oops')}
      content={i18next.t('ecommerceCoreUI:WrongPages.pageNotFoundText')}

    />
  </Column>
);

export default WrongPage;
